<template>
  <div class="contact">
    <TabBar_m />
    <div class="banner"></div>
    <div class="title">
      <h6>Contact us</h6>
      <i></i>
      <h3>联系我们</h3>
    </div>
    <div class="card_box">
      <div class="card_item">
        <div class="card_icon">
          <img src="../assets/image_m/contact_iphone.png" alt />
        </div>
        <div class="card_txt">
          <p>咨询电话</p>
          <p>029-88605419</p>
        </div>
      </div>
      <div class="card_item">
        <div class="card_icon">
          <img src="../assets/image_m/contact_email.png" alt />
        </div>
        <div class="card_txt">
          <p>联系邮箱</p>
          <p>yd@yuandacloud.com</p>
        </div>
      </div>
      <div class="card_item">
        <div class="card_icon">
          <img src="../assets/image_m/contact_zip.png" alt />
        </div>
        <div class="card_txt">
          <p>公司邮编</p>
          <p>710075</p>
        </div>
      </div>
      <div class="card_item">
        <div class="card_icon">
          <img src="../assets/image_m/contact_web.png" alt />
        </div>
        <div class="card_txt">
          <p>公司网址</p>
          <p>http://www .yuandacloud.com</p>
        </div>
      </div>
      <div class="card_item">
        <div class="card_icon">
          <img src="../assets/image_m/contact_location.png" alt />
        </div>
        <div class="card_txt">
          <p>公司地址</p>
          <p>
            陕西省西安市高新区科技二路72号西安
            软件园天泽大厦2楼
          </p>
        </div>
      </div>
    </div>
    <div class="map"></div>
    <Footer_m />
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.banner {
  background: url("../assets/image_m/home_banner.png") no-repeat;
  background-position: center 0;
  margin-top: 50px;
  background-size: 100%;
  &::before {
    content: "";
    display: block;
    padding-top: 100%;
  }
}
.title {
  padding: 16px;
  h6 {
    line-height: 15px;
    font-size: 10px;
    text-transform: uppercase;
  }
  i {
    display: block;
    width: 30px;
    height: 2px;
    background: #26acff;
    margin: 4px 0;
  }
  h3 {
    line-height: 25px;
    font-size: 18px;
    margin-bottom: 12px;
  }
}
.card_box {
  padding: 0 16px 24px;
  .card_item {
    padding: 16px;
    display: flex;
    align-items: center;

    border: 1px solid #dedede;
    .card_icon {
      height: 25px;
      width: 25px;
      margin-right: 12px;
      flex-shrink: 0;
      img {
        width: 100%;
      }
    }
    .card_txt p:nth-child(1) {
      line-height: 12px;
      font-size: 12px;
      margin-bottom: 4px;
    }
    .card_txt p:nth-child(2) {
      line-height: 18px;
      font-size: 16px;
    }
  }
}
.map {
  background: url("../assets/image_m/contact_map.png") no-repeat;
  background-position: center;
  background-size: 100%;
  height: 200px;
  position: relative;
}
</style>